// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1yXWL","comm-up":"comm-up__32oX2","comm-up-desc":"comm-up-desc__2qJJ3","sub":"sub__3bfRJ","svc-pkg":"svc-pkg__2BTYt","svc-pkg-desc":"svc-pkg-desc__6fk4t","svc-pkg-form":"svc-pkg-form__4fajT","buttons":"buttons__oKEfX","remaining-urgent":"remaining-urgent__3kRDc","remaining-tips":"remaining-tips__-L9fZ","heading":"heading__2-h5w"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/coms/UnderCommercialView/styles/main.scss
// module id = 2256
// module chunks = 1